module.exports = __webpack_public_path__ + "img/sdg_icon_15.06c1714f.png";